import { FormGroup, Input } from "reactstrap";

interface SelectCommonProp {
  data: string[];
  size: number;
  selectClass?: string
}

const SelectCommon = ({ data,size ,selectClass}: SelectCommonProp) => {
  return (
    <FormGroup className={selectClass}>
      <Input type="select" size={size}>
        {data.map((item, index) => (
          <option key={index}>{item}</option>
        ))}
      </Input>
    </FormGroup>
  );
};

export default SelectCommon;
